import { byWindowAction, sendRequest } from '@html/_common/utils';

export default class AOVisa {
  constructor(tourId) {
    this.tourId = tourId;
    this.initiated = false;
  }

  initiate() {
    byWindowAction(['scroll'], () => {
      this.loadCountries();
    });
    this.loadCountries();
  }

  loadCountries() {
    const $visaInformation = $('.js-ao-tour-good-to-know__about-countries-section-visas');
    if ($visaInformation.length > 0
        && $visaInformation.offset().top <= $(window).scrollTop() + $(window).height()
        && !this.initiated) {
      this.initiated = true;

      sendRequest('/api/tour/load', {
        action: 'country_list',
        id: this.tourId,
      }, (data) => {
        if (data && data.status === 'OK') {
          $('.js-ao-tour-good-to-know__about-countries-section-visas').html(data.component);
          let newMaxHeight = $('.js-ao-good-to-know__about-visas .js-ao-common-accordion__bottom-content').height() + $('.js-ao-tour-good-to-know__about-countries-section-visas').height();

          $('.js-ao-common-accordion:not(.js-ao-common-accordion--collapsed) .js-ao-good-to-know__about-visas.js-ao-common-accordion__bottom').css('max-height', `${newMaxHeight}px`);
          $('.js-ao-tour-good-to-know__visas-select').change((event) => {
            const $changedElement = $(event.currentTarget);
            if ($changedElement.val() !== '') {
              sendRequest(
                '/api/tour/load',
                {
                  action: 'check_visa',
                  id: this.tourId,
                  nationality: $changedElement.val(),
                  name: $(`.js-ao-tour-good-to-know__visas-select option[value="${$changedElement.val()}"]`).text(),
                },
                (response) => {
                  $('.js-ao-tour-good-to-know__visas-picked').html(response.component);
                  newMaxHeight += $('.js-ao-tour-good-to-know__visas-picked').height();

                  $('.js-ao-common-accordion:not(.js-ao-common-accordion--collapsed) .js-ao-good-to-know__about-visas.js-ao-common-accordion__bottom').css('max-height', `${newMaxHeight}px`);
                },
              );
            }
          });
        }
      });
    }
  }
}
